var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundCatalog2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 798,
    viewBox: "0 0 355 798",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_5433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 477.424,
    r: 319.576,
    transform: "rotate(-90 399 477.424)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 477.424,
    r: 319.576,
    transform: "rotate(-90 399 477.424)",
    fill: "url(#paint0_linear_1_5433)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 477.424,
    r: 319.576,
    transform: "rotate(-90 399 477.424)",
    fill: "url(#paint1_radial_1_5433)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 399,
    cy: 477.424,
    r: 319.826,
    transform: "rotate(-90 399 477.424)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_5433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 398.996,
    cy: 320.577,
    r: 319.576,
    transform: "rotate(90 398.996 320.577)",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.996,
    cy: 320.577,
    r: 319.576,
    transform: "rotate(90 398.996 320.577)",
    fill: "url(#paint2_linear_1_5433)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.996,
    cy: 320.577,
    r: 319.576,
    transform: "rotate(90 398.996 320.577)",
    fill: "url(#paint3_radial_1_5433)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 398.996,
    cy: 320.577,
    r: 319.826,
    transform: "rotate(90 398.996 320.577)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_5433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.574,
    cy: 399,
    r: 319.576,
    transform: "rotate(90 320.574 399)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.574,
    cy: 399,
    r: 319.576,
    transform: "rotate(90 320.574 399)",
    fill: "url(#paint4_linear_1_5433)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.574,
    cy: 399,
    r: 319.576,
    transform: "rotate(90 320.574 399)",
    fill: "url(#paint5_radial_1_5433)",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320.574,
    cy: 399,
    r: 319.826,
    transform: "rotate(90 320.574 399)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_5433)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 477.424,
    cy: 399,
    r: 319.576,
    transform: "rotate(-90 477.424 399)",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.424,
    cy: 399,
    r: 319.576,
    transform: "rotate(-90 477.424 399)",
    fill: "url(#paint6_radial_1_5433)",
    fillOpacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.424,
    cy: 399,
    r: 319.576,
    transform: "rotate(-90 477.424 399)",
    fill: "url(#paint7_linear_1_5433)",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 477.424,
    cy: 399,
    r: 319.826,
    transform: "rotate(-90 477.424 399)",
    stroke: "#E0E0E0",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_5433",
    x: 78.924,
    y: 157.348,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_5433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_5433",
    x: 78.9194,
    y: 0.50061,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_5433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_5433",
    x: 0.497665,
    y: 78.9242,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_5433"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_5433",
    x: 157.348,
    y: 78.9242,
    width: 640.152,
    height: 640.152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_1_5433"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_5433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5433",
    x1: 990.411,
    y1: 224.971,
    x2: 380.709,
    y2: 339.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_5433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(629.34 478.678) rotate(-180) scale(626.507)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.177083,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842199,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5433",
    x1: -386.38,
    y1: 427.293,
    x2: 317.91,
    y2: 701.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518602,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_5433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(398.996 320.577) rotate(179.827) scale(414.998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182292,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_5433",
    x1: 911.985,
    y1: 146.547,
    x2: 302.283,
    y2: 261.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_5433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.868 431.061) rotate(21.7389) scale(640.683 727.286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224735,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37505,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66121,
    stopColor: "#FFAC23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783675,
    stopColor: "#FF5334"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_5433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(601.719 320.575) rotate(137.992) scale(510.287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#3676F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#29BAB8",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#FFAC23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_5433",
    x1: 1068.83,
    y1: 146.547,
    x2: 459.133,
    y2: 261.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#3676F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3676F5",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCatalog2);
export default __webpack_public_path__ + "static/media/background-catalog2.9f77e4150900081e93f5b622e95d970e.svg";
export { ForwardRef as ReactComponent };